<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;"
        >前台业务</span
      >
      / 学员退费
    </div>
    <div class="listen-test-management">
      <section>
        <el-form
          @submit.native.prevent
          :inline="true"
          class="form-style"
          size="mini"
          label-width="500"
        >
          <el-form-item label="">
            <el-input
              style="width: 250px"
              v-model="student_form.realname"
              placeholder="请输入学员姓名"
              @keyup.enter.native="search"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
        </el-form>

        <el-row>
          <el-col :span="24">
            <div style="background: #f2f6fc; padding: 10px">
              <span style="color: #606266; font-weight: bold; font-size: 14px"
                >退费学员信息</span
              >

              <span style="margin-left: 20px; font-size: 14px">姓名:</span>
              <span style="color: #e6a23c; font-weight: bold; font-size: 14px">
                {{ chooseStudent.studentUserInfo.realname }}</span
              >
              <span style="margin-left: 20px; font-size: 14px">性别:</span>
              <span style="color: #e6a23c; font-weight: bold; font-size: 14px">
                {{ chooseStudent.studentUserInfo.sex }}</span
              >
              <span style="margin-left: 20px; font-size: 14px">所属校区:</span>
              <span style="color: #e6a23c; font-weight: bold; font-size: 14px">
                {{ chooseStudent.campusName }}</span
              >
              <span style="margin-left: 20px; font-size: 14px">平台账号:</span>
              <span style="color: #e6a23c; font-weight: bold; font-size: 14px">
                {{ chooseStudent.name }}</span
              >
              <span style="margin-left: 20px; font-size: 14px"
                >电子钱包余额:</span
              >
              <span style="color: #e6a23c; font-weight: bold; font-size: 14px">
                {{ chooseStudent.wallet }}</span
              >
            </div>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-row>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <span>退费日期</span>
              <el-date-picker
                size="mini"
                type="date"
                placeholder="请选择退费日期"
                v-model="ruleForm.date"
                style="width: 150px; margin-left: 10px"
                value-format="yyyy-MM-dd"
                placement="bottom-start"
              ></el-date-picker>
            </div>
          </el-col>

          <el-col :span="2">
            <div class="grid-content bg-purple-light">
              <el-checkbox
                style="margin-top: 3px"
                size="mini"
                v-model="checked"
                @change="getReceiptListForRefund"
                >包含物品</el-checkbox
              >
            </div>
          </el-col>
        </el-row>

        <div style="margin-top: 20px">
          <el-table
            size="mini"
            row-key="id"
            default-expand-all
            :tree-props="{ children: 'goodsList', hasChildren: 'hasChildren' }"
            :data="receipt_carry_List"
            :header-cell-style="{ background: '#f5f7fa' }"
          >
            <el-table-column fixed="left" label="收据号" width="150">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.num"
                  @click.native.prevent="LookReceipt(scope.row)"
                  type="primary"
                >
                  {{ (Array(7).join(0) + scope.row.num).slice(-7) }}
                </el-link>
              </template>
            </el-table-column>

            <el-table-column
              prop="charge_date"
              label="交费日期"
              width="200"
            ></el-table-column>

            <el-table-column
              align="center"
              label="项目名称"
              width="150"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.name">{{ scope.row.name }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="购买数量" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.buy_num">{{ scope.row.buy_num }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="购买单价" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.now_unit_price">{{
                  scope.row.now_unit_price
                }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="课消数量" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.num">{{ scope.row.costNum }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="计费单价" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.chargeprice">
                  {{ scope.row.chargeprice }}
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="标准价" width="150">
              <template slot-scope="scope">
                <span v-if="!scope.row.num">
                  <el-checkbox
                    v-model="scope.row.price_base"
                    @change="PriceBaseChange"
                    >标准价</el-checkbox
                  >
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column label="单位" width="150" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.unit">
                  {{ scope.row.unit }}
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column label="剩余数量" width="150" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.left_num">{{ scope.row.left_num }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="可退金额" width="150">
              <template slot-scope="scope">
                <span v-if="!scope.row.num">{{ scope.row.refund_mount }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="退费数量" width="150">
              <template slot-scope="scope">
                <span v-if="!scope.row.num">
                  <el-input-number
                    size="mini"
                    v-model="scope.row.refund_num"
                    label="请输入退费数量"
                    :max="scope.row.left_num"
                    @change="PriceBaseChange"
                  ></el-input-number>
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="退费金额" width="150">
              <template slot-scope="scope">
                <span v-if="!scope.row.num">
                  {{ scope.row.refund_total }}
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="50">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.charge_type"
                  @click.native.prevent="deleteRow('1', scope.row.id)"
                  type="text"
                  size="small"
                >
                  移除
                </el-button>

                <el-button
                  v-else
                  @click.native.prevent="deleteRow('2', scope.row.id)"
                  type="text"
                  size="small"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="background: #717f91; color: white; margin-top: 60px">
          <span style="margin-left: 5px">结算信息</span>
        </div>

        <el-row>
          <el-col :span="24">
            <div
              style="margin-top: 40px; margin-left: 20px"
              class="grid-content bg-purple-dark"
            >
              <el-form size="mini" :inline="true">
                <el-form-item label="电子钱包余额">
                  <span>{{ chooseStudent.wallet }}</span>
                </el-form-item>
                <br />

                <el-form-item label="退电子钱包">
                  <el-input
                    type="number"
                    v-model="wallet_refund_amout"
                    placeholder="请输入退款金额"
                    @change="PriceBaseChange"
                  ></el-input>
                </el-form-item>

                <el-form-item label="其他扣款金额">
                  <el-input
                    type="number"
                    v-model="other_refund_amout"
                    placeholder="请输入扣款金额"
                    @change="PriceBaseChange"
                  ></el-input>
                </el-form-item>

                <el-form-item label="备注">
                  <el-input
                    type="textarea"
                    v-model="carryremark"
                    placeholder="请输入备注信息"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div style="float: right; margin-right: 20px">
                <span style="margin-left: 20px"
                  >退费金额总计:
                  <span
                    style="color: #e6a23c; font-size: 18px; font-weight: bold"
                    >¥ {{ final_refund_amount }}</span
                  >
                </span>
              </div>
            </div>
          </el-col>
        </el-row>

        <div style="background: #717f91; color: white; margin-top: 20px">
          <span style="margin-left: 5px">退款账户</span>
        </div>

        <el-row>
          <el-col :span="12">
            <div style="margin-top: 40px" class="grid-content bg-purple">
              <el-form
                size="mini"
                ref="dynamicValidateForm"
                label-width="100px"
              >
                <el-form-item
                  v-for="(item, index) in RefundAccountArr"
                  :label="item.name"
                  :key="item.account_id"
                  :prop="'domains.' + index + '.amount'"
                >
                  <el-input
                    style="width: 80%"
                    size="mini"
                    placeholder="请输入此账号的退款金额"
                    v-model="item.amount"
                  >
                  </el-input>

                  <el-button
                    @click.prevent="removeAccount(item)"
                    icon="el-icon-delete"
                  ></el-button>
                </el-form-item>

                <el-form-item>
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      添加退款账号<i class="el-icon-arrow-down"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="item of AccountList"
                        :key="item.id"
                        @click.native="addAccount(item)"
                        >{{ item.name }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div style="margin-top: 20px; text-align: center">
              <el-button
                size="small"
                type="primary"
                @click="createRefundReceipt"
                >确认退费</el-button
              >
            </div>
          </el-col>
        </el-row>
      </section>

      <!--收费确认-->
      <el-dialog
        title="订单确认"
        :visible.sync="dialogVisible"
        width="30%"
        append-to-body
      >
        <div>
          <span>实交金额: </span>
          <span style="color: green; font-weight: bold; margin-left: 20px"
            >9000</span
          >
        </div>

        <div style="margin-top: 20px">
          <span>欠费金额: </span>
          <span style="color: red; font-weight: bold; margin-left: 20px"
            >1000</span
          >
        </div>

        <div style="margin-top: 20px">
          <span>支付方式: </span>

          <span style="margin-left: 20px">现金:</span> <span>8000</span>
          <span style="margin-left: 20px">微信:</span><span>1000</span>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="createChargeReceipt"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <el-dialog
        title="选择学员"
        :visible.sync="dialogVisible1"
        width="80%"
        top="5vh"
      >
        <el-form
          :inline="true"
          class="form-style"
          size="mini"
          label-width="500"
          @submit.native.prevent
        >
          <!--
          <el-form-item label="所属校区">
            <el-select v-model="student_form.educational_institution_campus_id" placeholder="请选择所属校区" @change="school" clearable style="width: 150px">
              <el-option v-for="(item, index) of school_list" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          -->
          <el-form-item label="">
            <el-input
              style="width: 250px"
              v-model="student_form.realname"
              placeholder="请输入学员姓名"
              @keyup.enter.native="search"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
        </el-form>

        <div class="table-style">
          <el-table
            size="mini"
            :data="tableData"
            height="60vh"
            stripe
            :header-cell-style="{ background: '#f5f7fa', color: '#909399' }"
            highlight-current-row
            @current-change="CurrentChange_Student"
          >
            <el-table-column width="50" label="序号">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 + (page_no - 1) * page_size }}</span>
              </template>
            </el-table-column>
            <el-table-column label="学员姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.realname }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="normal_state" label="学员状态">
              <template slot-scope="scope">
                <span v-if="scope.row.normal_state == '1'">试听</span>
                <span v-else-if="scope.row.normal_state == '2'">在读</span>
                <span v-else-if="scope.row.normal_state == '3'">休学</span>
                <span v-else-if="scope.row.normal_state == '4'">已退学</span>
                <span v-else>未知</span>
              </template>
            </el-table-column>

            <el-table-column prop="sex" label="性别">
              <template slot-scope="scope">
                <span>{{ scope.row.studentUserInfo.sex }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="平台账号"></el-table-column>
            <el-table-column
              label="所在班级"
              width="200"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.class_str }}</span>
              </template>
            </el-table-column>

            <el-table-column label="有效期">
              <template slot-scope="scope">
                <span>
                  <span v-if="scope.row.enddate">
                    {{ scope.row.enddate.slice(0, 10) }}
                  </span>
                  <span style="color: #e6a23c" v-else>请设置有效期</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 30px; text-align: right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-size="page_size"
            layout="total,prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible1 = false"
            >取消</el-button
          >
          <el-button size="small" type="primary" @click="Submit_ChooseStudent"
            >确定</el-button
          >
        </span>
      </el-dialog>

      <!--欠费单据提示-->
      <el-dialog title="欠费提示" :visible.sync="dialogVisible2" width="30%">
        <span
          >{{
            chooseStudent.studentUserInfo.realname
          }}有欠交收据，是否补交?</span
        >

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible2 = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="dialogVisible3 = true"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!--欠费单据提示-->
      <el-dialog title="补交费用" :visible.sync="dialogVisible3" width="80%">
        <div class="table-style">
          <el-table
            size="mini"
            :data="NoPayData"
            :header-cell-style="{ background: '#f5f7fa' }"
          >
            <el-table-column
              fixed="left"
              align="center"
              prop="charge_date"
              label="交费日期"
              width="100"
            ></el-table-column>

            <el-table-column
              fixed="left"
              align="center"
              label="收据号"
              width="100"
            >
              <template slot-scope="scope">
                <el-link
                  @click="getReceiptChargeGoodsList(scope.row.id)"
                  type="primary"
                  >{{ scope.row.code }}</el-link
                >
              </template>
            </el-table-column>

            <el-table-column align="center" label="类型" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'">
                  <span v-if="scope.row.charge_type == '1'">交费(新增)</span>
                  <span v-else-if="scope.row.charge_type == '2'"
                    >交费(扩科)</span
                  >
                  <span v-else-if="scope.row.charge_type == '3'"
                    >交费(续费)</span
                  >
                  <span v-else-if="scope.row.charge_type == '4'"
                    >交费(预存)</span
                  >
                </span>

                <span v-else-if="scope.row.type == '2'">退费</span>
                <span v-else-if="scope.row.type == '3'">结转</span>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="studentInfo.studentUserInfo.realname"
              label="姓名"
              width="150"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="studentInfo.name"
              label="平台账号"
              width="150"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="studentInfo.studentUserInfo.school_name"
              label="公立校"
              width="200"
            ></el-table-column>

            <el-table-column
              align="center"
              width="100"
              prop="studentInfo.studentUserInfo.gradeStr"
              label="年级"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="lession_str"
              label="课程"
              width="200"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="goods_str"
              label="物品"
              width="200"
            ></el-table-column>

            <el-table-column
              align="center"
              width="100"
              prop="other_amount"
              label="直减优惠"
            ></el-table-column>

            <el-table-column
              align="center"
              width="100"
              prop="total_amount"
              label="应交金额"
            ></el-table-column>

            <el-table-column
              align="center"
              width="100"
              prop="final_amount"
              label="交费金额"
            ></el-table-column>

            <el-table-column
              align="center"
              width="100"
              prop="not_pay_amount"
              label="欠交金额"
            ></el-table-column>

            <el-table-column
              align="center"
              width="100"
              prop="campusName"
              label="所属校区"
            ></el-table-column>

            <el-table-column
              align="center"
              width="100"
              prop="leaderName"
              label="业绩归属人"
            ></el-table-column>

            <el-table-column
              align="center"
              width="100"
              prop="remark"
              label="备注"
            ></el-table-column>
          </el-table>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible3 = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="createChargeReceipt"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <el-dialog
        title="收据信息"
        :visible.sync="DialogVisible4"
        width="80%"
        top="10vh"
      >
        <div
          class="dialog-body"
          v-if="ReceiptData.length > 0"
          style="margin-bottom: 20px"
        >
          <el-table
            size="small"
            ref="classTable"
            :data="ReceiptData"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#f1f7fe' }"
          >
            <el-table-column align="center" label="名称" width="200">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'"
                  >{{ scope.row.curriculumInfo.title }}
                </span>
                <span v-else-if="scope.row.type == '2'"
                  >{{ scope.row.goodsInfo.name }}
                </span>
                <span v-else>未知</span>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="subject_id"
              label="班级"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="original_unit_price"
              label="原价"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="buy_num"
              label="数量"
            ></el-table-column>

            <el-table-column align="center" label="单位">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'">次 </span>
                <span v-else-if="scope.row.type == '2'"
                  >{{ scope.row.goodsInfo.unit }}
                </span>
                <span v-else>未知</span>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="discount"
              label="折扣(%)"
            ></el-table-column>

            <el-table-column align="center" label="金额">
              <template slot-scope="scope">
                {{ scope.row.now_unit_price * scope.row.buy_num }}
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="give_num"
              label="赠送数量"
            ></el-table-column>
          </el-table>
        </div>

        <el-row>
          <el-col :span="12">
            <div>
              <div style="background: #f1f7fe; color: #606266; padding: 10px">
                <span style="margin-left: 5px">结算信息</span>
              </div>

              <el-row style="padding: 20px">
                <el-col :span="24">
                  <div class="grid-content bg-purple-dark">
                    <el-form
                      size="mini"
                      :model="Current_Receipt"
                      ref="ruleForm"
                      label-width="100px"
                      class="demo-ruleForm"
                      style="bold: 500"
                    >
                      <el-form-item label="合计金额">
                        <span>{{ Current_Receipt.total_amount }}</span>
                      </el-form-item>

                      <el-form-item label="直减优惠">
                        <span>{{ Current_Receipt.other_amount }}</span>
                      </el-form-item>

                      <el-form-item label="应交金额">
                        <span>{{
                          Current_Receipt.total_amount -
                            Current_Receipt.other_amount
                        }}</span>
                      </el-form-item>

                      <el-divider></el-divider>

                      <el-form-item label="使用电子钱包">
                        <span>{{ Current_Receipt.bullet_amount }}</span>
                      </el-form-item>

                      <el-form-item label="实交金额">
                        <span>{{ Current_Receipt.final_amount }}</span>
                      </el-form-item>

                      <el-form-item label="收款账户">
                        <div v-for="item of receiptAccountList" :key="item.id">
                          <span>{{ item.accountName }}</span>
                          <span style="margin-left: 10px">{{
                            item.amount
                          }}</span>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="background: #f1f7fe; color: #606266; padding: 10px">
              <span style="margin-left: 5px">其他信息</span>
            </div>

            <el-row style="padding: 20px">
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <el-form
                    size="mini"
                    :model="updateform"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                  >
                    <el-form-item label="交费类型">
                      <el-select
                        size="mini"
                        v-model="updateform.charge_type"
                        placeholder="请选择"
                        disabled
                      >
                        <el-option
                          v-for="item in shouju_type"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="发票编号">
                      <el-input v-model="updateform.fapiao"></el-input>
                    </el-form-item>

                    <el-form-item label="业绩归属人">
                      <el-select
                        clearable
                        v-model="updateform.leader"
                        placeholder="请选择业绩归属人"
                        disabled
                      >
                        <el-option
                          v-for="item in user_list"
                          :key="item.id"
                          :label="item.realname"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="备注">
                      <el-input
                        type="textarea"
                        v-model="updateform.remark"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </el-col>
            </el-row>

            <div></div>
          </el-col>
        </el-row>

        <div slot="footer" style="margin-top: 20px" class="dialog-footer">
          <el-button size="small" @click="DialogVisible4 = false"
            >关 闭</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getFormalStudentListForRefund,
  getEducationalInstitutionCampusList,
  getCampusAccountList,
  getCampusUserList,
  createChargeReceipt,
  getReceiptListForRefund,
  createRefundReceipt,
  getReceiptChargeGoodsList,
  getReceiptAccountList,
} from '@/api/educational.js'

export default {
  name: 'refund',

  data() {
    return {
      //页码管理
      page_no: 1,
      page_size: 20,
      total: 0,

      //结转
      checked: false, //是否包含物品
      checked1: false, //以标准价计费
      receipt_carry_List: [], //可结转收据列表
      other_refund_amout: 0, //其他扣款金额
      wallet_refund_amout: 0, //退电子钱包余额
      final_refund_amount: 0, //最终结算金额
      total_refund_amount: 0,

      carryremark: '', //结转备注信息
      RefundGoodsArr: [], //所有退费商品

      RefundAccountArr: [], //退款账户

      dialogVisible: false,
      dialogVisible1: false, //选择学员弹窗
      chooseStudent: {
        educational_institution_campus_id: '',
        name: '',
        studentUserInfo: {
          realname: '',
          sex: '',
        },
      },
      chooseStudent_current: {},
      formInline: {
        user: '',
        region: '',
        region1: '',
      },

      //意向学员转公开课试听学员

      state: '1',

      curriculum_class_price: '', //班级商品实收价格
      haschoose_class: false, //是否选择了班级
      formLabelWidth: '120px',
      haschoose_good: false, //是否选择了商品
      haschoose_plan: false,
      haschoose_teachplan: false,

      total_price: 0,
      Audition_StudentData: [],
      Audition_GoodsData: [],

      num: '1',
      input: '0',

      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      outerVisible: false,

      teaching_plan_list: [], //所选教学计划ID

      activeName: 'first',
      name: '',
      status: '全部',
      listenTestStatus: '1',
      timeScope: '',
      tableData: [],

      Goodslist: [],
      goodslist: [],

      //订单state
      order_state: '',

      //查询所有在读学员
      student_form: {
        realname: '',
        leader: '',
        phone_a_num: '',
        normal_state: '2',
        educational_institution_campus_id: '',
      },
      school_list: [],

      chooseCourse: {}, //已选课程
      chooseFormalClass: {},
      OrderData: [],
      GoodsData: [],

      //计算物品总价和课程总价
      goods_totalprice: 0,
      course_totalprice: 0,
      goods_and_course_price: 0,

      //直减优惠
      reduce_price: 0,
      real_pay: 0, //实缴金额
      e_wallet_reduce: 0,

      //分校收款账户
      AccountList: [],
      receipt_num: '', //发票编号
      user_list: [],

      //商品信息
      goodsArr: [],

      //其他信息
      ruleForm: {
        fapiao: '', //
        leader: '',
        remark: '',
        charge_type: '',
        date: '',
        accountArr: [],
      },
      dialogVisible2: false, //欠交提示
      dialogVisible3: false, //补交欠款

      DialogVisible4: false, //收据信息

      NoPayData: [], //欠交收据列表
      receiptAccountList: [], //账户列表
      updateform: {
        id: '',
        bill_code: '',
        leader: '',
        remark: '',
        educational_institution_campus_id: '',
        charge_type: null,
      },
      shouju_type: [
        {
          id: 1,
          name: '新增',
        },
        {
          id: 2,
          name: '扩科',
        },
        {
          id: 3,
          name: '续费',
        },
        {
          id: 4,
          name: '预存',
        },
      ],
      ReceiptData: [], //收据详情
      Current_Receipt: [], //当前收据
    }
  },

  watch: {
    goodslist() {
      console.log('已选商品信息发生变化')
      console.log(this.goodslist)
    },
    curriculum_class_price() {
      console.log('课程实收价格发生变化')
      console.log(this.curriculum_class_price)
    },
    reduce_price() {
      this.real_pay =
        this.goods_and_course_price - this.reduce_price - this.e_wallet_reduce
    },
    e_wallet_reduce() {
      this.real_pay =
        this.goods_and_course_price - this.reduce_price - this.e_wallet_reduce
    },
    chooseStudent() {
      this.getReceiptListForRefund()
      this.getCampusAccountList()
    },
    '$store.state.user.selected_schools': {
      handler(newValue, oldValue) {
        console.log('校区监听')
        console.log(newValue)
        console.log(oldValue)
        if (newValue.length == 0) {
          this.$message.warning('目标校区不能为空')
        }
      },
      deep: true,
    },
  },
  computed: {
    //应交金额
    prepare_pay: function() {
      return (
        this.goods_and_course_price - this.reduce_price - this.e_wallet_reduce
      )
    },

    //预存金额与欠费金额
    prestore: function() {
      return this.real_pay - this.prepare_pay
    },
  },
  mounted() {
    console.log('学员收费')
    this.ruleForm.date = new Date()
    this.getEducationalInstitutionCampusList() //获取分校列表
  },

  methods: {
    PriceBaseChange() {
      console.log('计价标准发生变化')
      console.log(this.receipt_carry_List)

      for (let k = 0; k < this.receipt_carry_List.length; k++) {
        for (let j = 0; j < this.receipt_carry_List[k].goodsList.length; j++) {
          if (this.receipt_carry_List[k].goodsList[j].price_base) {
            //TODO //按原单价计费
            this.receipt_carry_List[k].goodsList[
              j
            ].chargeprice = this.receipt_carry_List[k].goodsList[
              j
            ].original_unit_price

            this.receipt_carry_List[k].goodsList[j].refund_mount = parseFloat(
              this.receipt_carry_List[k].goodsList[j].buy_num *
                this.receipt_carry_List[k].goodsList[j].now_unit_price -
                this.receipt_carry_List[k].goodsList[j].costNum *
                  this.receipt_carry_List[k].goodsList[j].original_unit_price
            ).toFixed(2)

            this.receipt_carry_List[k].goodsList[j].refund_total = (
              (this.receipt_carry_List[k].goodsList[j].refund_mount /
                this.receipt_carry_List[k].goodsList[j].left_num) *
              this.receipt_carry_List[k].goodsList[j].refund_num
            ).toFixed(2)
          } else {
            //按折后单价计费
            this.receipt_carry_List[k].goodsList[
              j
            ].chargeprice = this.receipt_carry_List[k].goodsList[
              j
            ].now_unit_price
            this.receipt_carry_List[k].goodsList[j].refund_mount = parseFloat(
              this.receipt_carry_List[k].goodsList[j].buy_num *
                this.receipt_carry_List[k].goodsList[j].now_unit_price -
                this.receipt_carry_List[k].goodsList[j].costNum *
                  this.receipt_carry_List[k].goodsList[j].now_unit_price
            ).toFixed(2)

            this.receipt_carry_List[k].goodsList[j].refund_total = (
              (this.receipt_carry_List[k].goodsList[j].refund_mount /
                this.receipt_carry_List[k].goodsList[j].left_num) *
              this.receipt_carry_List[k].goodsList[j].refund_num
            ).toFixed(2)
          }
        }
      }

      //计算总结算金额
      this.final_refund_amount = 0
      for (let k = 0; k < this.receipt_carry_List.length; k++) {
        for (let j = 0; j < this.receipt_carry_List[k].goodsList.length; j++) {
          this.final_refund_amount =
            parseFloat(this.final_refund_amount) +
            parseFloat(this.receipt_carry_List[k].goodsList[j].refund_total)
          console.log('结算总金额')
          console.log(this.final_refund_amount)
        }
      }

      this.total_refund_amount = this.final_refund_amount

      this.final_refund_amount =
        parseFloat(this.final_refund_amount) -
        parseFloat(this.other_refund_amout) +
        parseFloat(this.wallet_refund_amout)

      this.final_refund_amount = this.final_refund_amount.toFixed(2)
    },

    //确认退费接口
    createRefundReceipt() {
      console.log('退费参数')
      console.log('校区ID')
      console.log(this.chooseStudent.educational_institution_campus_id)
      console.log('学生ID')
      console.log(this.chooseStudent.id)
      //TODO 结转参数
      this.RefundGoodsArr = []
      for (let k = 0; k < this.receipt_carry_List.length; k++) {
        for (let j = 0; j < this.receipt_carry_List[k].goodsList.length; j++) {
          const good = {
            original_receipt_id: this.receipt_carry_List[k].goodsList[j]
              .receipt_id, //原收据号
            id: this.receipt_carry_List[k].goodsList[j].id, //ID
            type: this.receipt_carry_List[k].goodsList[j].type, //类型
            class_id: this.receipt_carry_List[k].goodsList[j].class_id,
            name: this.receipt_carry_List[k].goodsList[j].name, //商品名称
            unit_price:
              this.receipt_carry_List[k].goodsList[j].refund_total /
              this.receipt_carry_List[k].goodsList[j].refund_num, //单价
            refund_num: this.receipt_carry_List[k].goodsList[j].refund_num, //退费数量
            total_amount: this.receipt_carry_List[k].goodsList[j].refund_total, //退费总额
          }

          if (this.receipt_carry_List[k].goodsList[j].refund_num >= 0) {
            this.RefundGoodsArr.push(good)
          }
        }
      }

      console.log('退费参数')
      console.log('total_amount')
      console.log(this.total_refund_amount)

      console.log('final_amount')
      console.log(this.final_refund_amount)

      if (this.RefundAccountArr.length == 0) {
        this.$message.warning('请添加退款账号')
        return
      }

      console.log('this.RefundGoodsArr')
      console.log(this.RefundGoodsArr)

      this.$confirm('确定对列表中的所有收据,进行退费操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        createRefundReceipt({
          educational_institution_campus_id: this.chooseStudent
            .educational_institution_campus_id, //校区id
          student_user_id: this.chooseStudent.id, //学员ID
          total_amount: this.total_refund_amount, //订单总额
          other_amount: this.other_refund_amout, //其他扣款
          bullet_amount: this.chooseStudent.wallet, //电子钱包余额
          final_amount: this.final_refund_amount, //最终金额
          remark: this.carryremark, //备注
          charge_date: this.ruleForm.date, //TODO 退费日期
          goodsArr: JSON.stringify(this.RefundGoodsArr), //退费物品
          accountArr: JSON.stringify(this.RefundAccountArr), //账号信息
        }).then((res) => {
          console.log('退费操作')
          console.log(res)
          if (res.is_create) {
            this.$message.success('退费成功')
          }
        })
      })
    },

    //移除所选课程
    deleteRow(cmd, id) {
      if (cmd == '1') {
        console.log('删除单据')
        for (let k = 0; k < this.receipt_carry_List.length; k++) {
          if (this.receipt_carry_List[k].id == id) {
            this.receipt_carry_List.splice(k, 1)
          }
        }
      } else if (cmd == '2') {
        console.log('删除商品')
        for (let k = 0; k < this.receipt_carry_List.length; k++) {
          for (
            let j = 0;
            j < this.receipt_carry_List[k].goodsList.length;
            j++
          ) {
            if (this.receipt_carry_List[k].goodsList[j].id == id) {
              this.receipt_carry_List[k].goodsList.splice(j, 1)

              if (this.receipt_carry_List[k].goodsList.length == 0) {
                this.receipt_carry_List.splice(k, 1)
              }
            }
          }
        }
      }

      // rows.splice(index, 1);
    },

    //获取学校列表
    getEducationalInstitutionCampusList() {
      getEducationalInstitutionCampusList().then((res) => {
        console.log('获得分校列表')
        console.log(res)
        this.school_list = res.educational_institution_campus_list
      })
    },

    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.chooseStudent.educational_institution_campus_id,
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
      })
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    ConformInfo() {
      if (!this.chooseStudent.educational_institution_campus_id) {
        console.log('请选择校区ID')
        this.$message.warning('请选择需要结转的学员')
        return
      }

      this.course_totalprice = 0
      this.goods_totalprice = 0
      this.goods_and_course_price = 0
      for (let k = 0; k < this.OrderData.length; k++) {
        if (this.OrderData[k].goodstype == '1') {
          console.log('此商品为课程')
          console.log(this.OrderData[k])
          this.course_totalprice =
            this.course_totalprice +
            this.OrderData[k].discount_uniprice * this.OrderData[k].total_num
        } else if (this.OrderData[k].goodstype == '2') {
          this.goods_totalprice =
            this.goods_totalprice +
            this.OrderData[k].discount_uniprice * this.OrderData[k].total_num
          console.log('此商品为物品')
          console.log(this.OrderData[k])
        }
      }

      this.goods_and_course_price =
        this.course_totalprice + this.goods_totalprice
      this.real_pay = this.goods_and_course_price
      this.outerVisible = true

      this.getCampusUserList()
    },

    PrepareChargeReceipt() {
      this.dialogVisible = true
      this.goodsArr = [] //清空商品列表

      for (let k = 0; k < this.OrderData.length; k++) {
        const goodsArrinfo = {
          id: this.OrderData[k].id,
          type: this.OrderData[k].goodstype,
          name: this.OrderData[k].title,
          original_unit_price: this.OrderData[k].original_unitprice,
          buy_num: this.OrderData[k].total_num,
          give_num: this.OrderData[k].gift_num,
          discount: this.OrderData[k].discount_percent,
          now_unit_price: this.OrderData[k].discount_uniprice,
          total_amount:
            this.OrderData[k].discount_uniprice * this.OrderData[k].total_num,
        }

        this.goodsArr.push(goodsArrinfo)
      }
    },

    //创建收据接口
    createChargeReceipt() {
      console.log('订单参数确认')
      console.log('---------------')
      console.log('校区ID')
      console.log(this.chooseStudent.educational_institution_campus_id)
      console.log('学生ID')
      console.log(this.chooseStudent.id)

      console.log('合计金额')
      console.log(this.goods_and_course_price)
      console.log('电子钱包冲减')
      console.log(this.e_wallet_reduce)
      console.log('直减优惠')
      console.log(this.reduce_price)

      console.log('预存/欠缴')
      console.log(this.prestore)

      console.log('应交金额')
      console.log(this.prepare_pay)

      console.log('业绩归属人')
      console.log(this.ruleForm.leader)
      console.log('备注')
      console.log(this.ruleForm.remark)

      console.log('交费日期')
      console.log(this.ruleForm.date)

      console.log('交费类型')
      console.log(this.ruleForm.charge_type)

      console.log('商品信息')
      console.log(this.goodsArr)
      console.log('账户信息')
      console.log(this.ruleForm.accountArr)

      console.log('-----------------------')

      createChargeReceipt({
        educational_institution_campus_id: this.chooseStudent
          .educational_institution_campus_id,
        student_user_id: this.chooseStudent.id,
        total_amount: this.goods_and_course_price, //合计金额
        bullet_amount: this.e_wallet_reduce, //电子钱包冲减
        other_amount: this.reduce_price, //直减优惠
        not_pay_amount: this.prestore < 0 ? Math.abs(this.prestore) : 0, //欠缴金额
        prestore_amount: this.prestore > 0 ? Math.abs(this.prestore) : 0, //预存金额
        final_amount: this.prepare_pay, // 应交金额
        leader: this.ruleForm.leader, //业绩归属人
        remark: this.ruleForm.remark, //备注
        charge_type: this.ruleForm.charge_type, //1新增 2扩科 3续费 4预存
        goodsArr: JSON.stringify(this.goodsArr), //商品信息
        accountArr: JSON.stringify(this.ruleForm.accountArr), //账号付款信息
        charge_date: this.ruleForm.date,
      }).then((res) => {
        console.log('生成收据')
        console.log(res)
        if (res.is_create) {
          this.$message.success('收费成功')
          this.dialogVisible = false
          this.outerVisible = false

          this.$router.push({ name: 'order-report' })

          /*    this.chooseStudent={};
        this.goods_and_course_price=0;
        this.e_wallet_reduce=0;
        this.reduce_price=0;
        this.prestore=0;
        this.prepare_pay=0;
        this.ruleForm={};
        this.goodsArr=[];*/
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    //移除收款账号
    removeAccount(item) {
      var index = this.RefundAccountArr.indexOf(item)
      if (index !== -1) {
        this.RefundAccountArr.splice(index, 1)
      }
    },
    //添加收款账号
    addAccount(item) {
      this.RefundAccountArr.push({
        amount: 0,
        name: item.name,
        account_id: item.id,
      })
    },

    chooseClass(val) {
      console.log('子组件传值-已选班级')
      console.log(val)

      this.chooseFormalClass = val
    },

    chooseGoodList(val) {
      console.log('子组件传值-已选物品')
      console.log(val)

      for (let k = 0; k < val.length; k++) {
        console.log(val[k])

        const form_order = {
          id: val[k].id,
          title: val[k].name,
          original_unitprice: val[k].present_price,
          total_num: 1,
          discount_percent: 100,
          discount_uniprice: val[k].present_price,
          total_price: val[k].present_price,
          gift_num: 0,
          goodstype: '2',
        }

        this.OrderData.push(form_order)
      }
    },

    //返回所选的课程
    chooseCurriculum(val) {
      console.log('子组件传值-已选课程')
      console.log(val)

      const form_order = {
        id: val.id,
        title: val.title,
        original_unitprice: (val.campusPrice / val.number_of_courses).toFixed(
          2
        ),
        total_num: val.number_of_courses,
        discount_percent: 100,
        discount_uniprice: (val.campusPrice / val.number_of_courses).toFixed(2),
        total_price: val.campusPrice,
        gift_num: 0,
        goodstype: '1',
      }

      this.OrderData.push(form_order)
    },

    Cancel_Order() {
      console.log('取消订单')
      this.total_price = 0
      this.outerVisible = false
    },

    //获得校区收款账户
    getCampusAccountList() {
      getCampusAccountList({
        campusId: this.chooseStudent.educational_institution_campus_id,
      }).then((res) => {
        console.log('获得分校收款账户')
        console.log(res)
        this.AccountList = res.accountList
      })
    },

    search() {
      if (this.$store.state.user.selected_schools.length == 0) {
        this.$message.warning('请选择校区')
      } else {
        this.page_no = 1
        this.getFormalStudentListForRefund()
      }
    },
    school(val) {
      console.log(val, 555)
      getFormalStudentListForRefund({
        realname: this.student_form.realname,
        leader: '',
        phone_a_num: '',
        // normal_state: this.student_form.normal_state,
        campusIds: JSON.stringify([val]),
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询所有在读学员')
        console.log(res)

        this.tableData = res.studentList
        this.total = res.total

        if (res.total == 0) {
          console.log('暂无学员数据')
        } else if (res.total == 1) {
          console.log('查到1个学员')
          this.chooseStudent = this.tableData[0]
        } else {
          console.log('具有多个学员')
          this.dialogVisible1 = true
        }
      })
    },
    //查询在读学员
    getFormalStudentListForRefund() {
      getFormalStudentListForRefund({
        realname: this.student_form.realname,
        leader: '',
        phone_a_num: '',
        // normal_state: this.student_form.normal_state,
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询所有在读学员')
        console.log(res)

        this.tableData = res.studentList
        this.total = res.total
        for (let k = 0; k < this.tableData.length; k++) {
          this.tableData[k].classlist = []
          for (let j = 0; j < this.tableData[k].stuClassArr.length; j++) {
            // console.log(this.tableData2[k].stuClassArr[j].classInfo.name);
            this.tableData[k].classlist.push(
              this.tableData[k].stuClassArr[j].className
            )
          }

          this.tableData[k].class_str = this.tableData[k].classlist.join(' , ')
        }

        if (res.total == 0) {
          console.log('暂无学员数据')
        } else if (res.total == 1) {
          console.log('查到1个学员')
          this.chooseStudent = this.tableData[0]
        } else {
          console.log('具有多个学员')
          this.dialogVisible1 = true
        }
      })
    },

    handleClick() {},
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.page_no = val
      this.getFormalStudentListForRefund()
    },
    editStudent() {},

    CurrentChange_Student(val) {
      console.log('选择了学员')
      console.log(val)
      this.chooseStudent = val
      this.chooseStudent_current = val
    },

    Cancel_ChooseStudent() {
      this.dialogVisible1 = false
      console.log('取消选择学员')
    },
    Submit_ChooseStudent() {
      this.dialogVisible1 = false
      this.chooseStudent = this.chooseStudent_current
    },

    //可结转单据查询

    getReceiptListForRefund() {
      this.receipt_carry_List = [] //清空收据信息
      getReceiptListForRefund({
        student_user_id: this.chooseStudent.id,
      }).then((res) => {
        console.log('可结转单据查询')
        console.log(res)

        //this.receipt_carry_List = res.receiptList;
        //TODO 组合结转收据信息
        for (let k = 0; k < res.receiptList.length; k++) {
          const carry_List = {
            id: res.receiptList[k].id, //ID
            bill_code: res.receiptList[k].bill_code, //收据号
            charge_date: res.receiptList[k].charge_date, //交费日期
            num: res.receiptList[k].num,
            bullet_amount: res.receiptList[k].bullet_amount,
            final_amount: res.receiptList[k].final_amount,
            not_pay_amount: res.receiptList[k].not_pay_amount,
            other_amount: res.receiptList[k].other_amount,
            prestore_amount: res.receiptList[k].prestore_amount,
            total_amount: res.receiptList[k].total_amount,
            charge_type: res.receiptList[k].charge_type,
            leader: res.receiptList[k].leader,
            type: res.receiptList[k].type,
            remark: res.receiptList[k].remark,

            goodsList: [],
          }
          for (let j = 0; j < res.receiptList[k].goodsList.length; j++) {
            const goodsinfo = {}
            if (res.receiptList[k].goodsList[j].type == 1) {
              console.log('课程商品')
              goodsinfo.name =
                res.receiptList[k].goodsList[j].curriculumInfo.title
              goodsinfo.id = res.receiptList[k].goodsList[j].id
              goodsinfo.buy_num = res.receiptList[k].goodsList[j].buy_num
              goodsinfo.now_unit_price =
                res.receiptList[k].goodsList[j].now_unit_price
              goodsinfo.original_unit_price =
                res.receiptList[k].goodsList[j].original_unit_price

              goodsinfo.costNum = res.receiptList[k].goodsList[j].costNum
              goodsinfo.price_base = false //计费单价，默认是按折后价计费
              goodsinfo.type = res.receiptList[k].goodsList[j].type
              goodsinfo.unit = '次'
              goodsinfo.left_num =
                res.receiptList[k].goodsList[j].buy_num -
                res.receiptList[k].goodsList[j].costNum //剩余课时
              goodsinfo.refund_mount = parseFloat(
                (res.receiptList[k].goodsList[j].buy_num -
                  res.receiptList[k].goodsList[j].costNum) *
                  res.receiptList[k].goodsList[j].now_unit_price
              ).toFixed(2) //可退金额

              goodsinfo.refund_num = 0 //退费数量
              goodsinfo.refund_total = 0 //退费金额

              goodsinfo.chargeprice =
                res.receiptList[k].goodsList[j].now_unit_price //扣费单价 默认为折后价计费

              goodsinfo.receipt_id = res.receiptList[k].goodsList[j].receipt_id
              goodsinfo.class_id = res.receiptList[k].goodsList[j].class_id
            } else if (res.receiptList[k].goodsList[j].type == 2) {
              console.log('物品商品')
              //是否包含物品
              goodsinfo.name = res.receiptList[k].goodsList[j].goodsInfo.name
              goodsinfo.id = res.receiptList[k].goodsList[j].id
              goodsinfo.buy_num = res.receiptList[k].goodsList[j].buy_num
              goodsinfo.now_unit_price =
                res.receiptList[k].goodsList[j].now_unit_price

              //判断物品是否有课消
              if (res.receiptList[k].goodsList[j].costNum) {
                console.log('物品有课消')
                goodsinfo.costNum = res.receiptList[k].goodsList[j].costNum
              } else {
                goodsinfo.costNum = 0
              }

              goodsinfo.price_base = false //计费单价，默认是按折后价计费
              goodsinfo.type = res.receiptList[k].goodsList[j].type
              goodsinfo.original_unit_price =
                res.receiptList[k].goodsList[j].original_unit_price
              goodsinfo.unit = res.receiptList[k].goodsList[j].goodsInfo.unit
              goodsinfo.left_num = res.receiptList[k].goodsList[j].buy_num //剩余数量
              goodsinfo.refund_mount = parseFloat(
                res.receiptList[k].goodsList[j].buy_num *
                  res.receiptList[k].goodsList[j].now_unit_price
              ).toFixed(2) //可退金额

              goodsinfo.refund_num = 0 //退费数量
              goodsinfo.refund_total = 0 //退费金额

              goodsinfo.chargeprice =
                res.receiptList[k].goodsList[j].now_unit_price //扣费单价 默认为折后价计费
            }
            goodsinfo.receipt_id = res.receiptList[k].goodsList[j].receipt_id
            console.log('商品信息')
            console.log(goodsinfo)

            if (this.checked) {
              carry_List.goodsList.push(goodsinfo)
            } else {
              if (goodsinfo.type == '1') {
                carry_List.goodsList.push(goodsinfo)
              }
            }
          }

          this.receipt_carry_List.push(carry_List)
        }

        console.log('经过过滤的收据信息')
        console.log(this.receipt_carry_List)

        if (this.receipt_carry_List.length > 0) {
          this.$notify.info({
            title: '重要提醒',
            message: '请移除不需要退费的收据或商品后,再进行退费操作。',
          })
        }
      })
    },

    //查看收据
    LookReceipt(row) {
      console.log(row)

      this.getReceiptChargeGoodsList(row)
    },

    //查询收据商品
    getReceiptChargeGoodsList(row) {
      this.DialogVisible4 = true
      console.log('查询收据详情')
      console.log(row)
      this.Current_Receipt = row
      this.goods_and_course_price = 0
      this.updateform.id = row.id
      this.updateform.bill_code = row.bill_code
      this.updateform.leader = row.leader
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.remark = row.remark
      this.updateform.charge_type = row.charge_type

      this.ReceiptData = []
      getReceiptChargeGoodsList({
        receipt_id: row.id,
      }).then((res) => {
        console.log('查询收据对应的商品')
        console.log(res)
        this.ReceiptData = res.receiptChargeGoodsList

        for (let k = 0; k < res.receiptChargeGoodsList.length; k++) {
          console.log(res.receiptChargeGoodsList[k].total_amount)
          this.goods_and_course_price =
            this.goods_and_course_price +
            res.receiptChargeGoodsList[k].total_amount
        }
      })
      //查询收据对应的账号
      getReceiptAccountList({
        receipt_id: row.id,
      }).then((res) => {
        console.log('查询收据对应的账户')
        console.log(res)
        this.receiptAccountList = res.receiptAccountList
      })

      this.getCampusUserList()
    },
  },
}
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
}
.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
  span {
    color: rgba(0, 0, 0, 0.45);
  }
}
.listen-test-management {
  min-height: calc(100% - 30px);
  background-color: #fff;
  margin: 10px;
  border-radius: 5px;
  section {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;

    .form-style {
      margin-top: 10px;
      width: 100%;
    }

    .table-style {
      margin-top: 0px;
    }
  }
  .form-style-open {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
  background-color: #e4e9f0 !important;
  color: #333333;
}
</style>

<style>
.listen-test-management .el-dialog__body {
  padding: 20px 20px;
}
</style>
